<!-- 积分充值-充值详情 -->

<template>
  <div class="recharge-lists-dialog">
    <w-dialog ref="dialogRef" title="积分充值订单详情" width="60%" top="10vh" :hideFooter="true">
      <div class="basic-info">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="flex">
              <div class="flex-shrink info-title">商品名称</div>
              <div>{{ basicInfo.im_title }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex-shrink info-title">订单金额</div>
              <div>{{ basicInfo.or_money }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex-shrink info-title">会员手机</div>
              <div>{{ basicInfo.m_mobile }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex s-m-t">
              <div class="flex-shrink info-title">订单号码</div>
              <div>{{ basicInfo.or_sn }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex s-m-t">
              <div class="flex-shrink info-title">下单时间</div>
              <div>{{ basicInfo.or_ctime }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex s-m-t">
              <div class="flex-shrink info-title">支付状态</div>
              <div class="status-text" :class="statusColors(basicInfo.or_pay_status)">{{ basicInfo.or_status_text }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex s-m-t">
              <div class="flex-shrink info-title">支付时间</div>
              <div>{{ basicInfo.or_pay_time }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex s-m-t">
              <div class="flex-shrink info-title">支付方式</div>
              <div>{{ basicInfo.orp_name }}</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <w-title :title_name="'退款明细'"></w-title>
        <common-table ref="tableRef" tableHeight="400" :columns="tableColumns" :ispaging="false"
          :tableData="basicInfo.refund_order">
        </common-table>
      </div>
    </w-dialog>
  </div>
</template>

<script>
import { ref, nextTick, } from "vue";
import { VipApi, } from "@/plugins/api.js";

export default {
  emits: ["submit"],
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const basicInfo = ref({});
    const tableRef = ref(null);
    /** 表格配置数据 */
    const tableColumns = ref([
      {
        prop: "orr_refund_sn",
        label: "退款单号",
      },
      {
        prop: "orr_refund_money",
        label: "退款金额",
      },
      {
        prop: "orr_status_text",
        label: "退款方式",
      },
      {
        prop: "orr_refund_user",
        label: "退款确认人",
      },
      {
        prop: "orr_refund_pay_time",
        label: "退款时间",
      },
    ]);

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      getDetail();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     *  获取详情
     * 
     **/
    const getDetail = () => {
      VipApi.getIntegralOrderInfo({ sn: currentRow.value.or_sn, }).then((res) => {
        if (res.Code === 200) {
          basicInfo.value = res.Data;
          dialogRef.value.show();
          nextTick(() => {
            tableRef.value.tableLoad();
          })
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     *  状态样式
     * 
     **/
    const statusColors = (status) => {
      let status_color = '';  // 1-待交 2-已支付 3-订单取消 4-申请退款中 5-已退款
      switch (status) {
        case 1:
          status_color = 'btn-red';
          break;
        case 2:
          status_color = 'btn-green';
          break;
        case 3:
          status_color = 'btn-grey';
          break;
        case 4:
          status_color = 'btn-grey';
          break;
        case 5:
          status_color = 'btn-black';
          break;
      }
      return status_color;
    }

    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      basicInfo,
      getDetail,
      statusColors,
      tableColumns,
      tableRef,
    };
  },
};
</script>

<style lang="scss">
.recharge-lists-dialog {
  .basic-info {
    border-radius: 5px;
    margin-bottom: 30px;
    padding: 15px;
    background-color: var(--search-uncheck-bg-color);
  }

  .info-title {
    color: #92979E;
    margin-right: 20px;
  }
}
</style>